export enum Screens {
  LoadingScreen,
  ErrorScreen,
  SubscriptionsScreen,
  SignUpScreen,
  SignInScreen,
  ForgotPasswordScreen,
  AlreadySubscribedScreen,
  PaymentScreen,
  SuccessScreen,
  EmailVerifyScreen,
  EmailVerificationSuccessScreen,
  SocialAuthSuccessScreen,
  PaymentPendingScreen,
}
